import { Plus, Trash } from "@phosphor-icons/react";
import { Section } from "./Section";

const LEVELS = ["Native", "Fluent", "Professional", "Conversational", "Basic"];

export default function LanguagesSection({ resume, setResume, open, onToggle }) {
  const langs = resume.languages || [];

  const add = () =>
    setResume((r) => ({
      ...r,
      languages: [...(r.languages || []), { id: crypto.randomUUID(), name: "", level: "" }],
    }));
  const update = (i, k, v) =>
    setResume((r) => {
      const next = [...(r.languages || [])];
      next[i] = { ...next[i], [k]: v };
      return { ...r, languages: next };
    });
  const remove = (i) =>
    setResume((r) => ({ ...r, languages: (r.languages || []).filter((_, idx) => idx !== i) }));

  return (
    <Section id="languages" title="Languages known" open={open} onToggle={onToggle}>
      <div className="space-y-3">
        {langs.map((lang, i) => (
          <div key={lang.id} className="border border-black/10 p-3 grid grid-cols-[1fr_auto_auto] gap-2 items-center" data-testid={`language-item-${i}`}>
            <input
              className="field-input"
              placeholder="Language (e.g. English)"
              value={lang.name}
              onChange={(e) => update(i, "name", e.target.value)}
              data-testid={`lang-name-${i}`}
            />
            <select
              className="field-input"
              value={lang.level}
              onChange={(e) => update(i, "level", e.target.value)}
              data-testid={`lang-level-${i}`}
            >
              <option value="">Level…</option>
              {LEVELS.map((lv) => (
                <option key={lv} value={lv}>{lv}</option>
              ))}
            </select>
            {langs.length > 1 && (
              <button
                onClick={() => remove(i)}
                className="text-neutral-400 hover:text-[#FF2A00] p-2"
                data-testid={`remove-language-${i}`}
              >
                <Trash size={14} weight="bold" />
              </button>
            )}
          </div>
        ))}
        <button onClick={add} className="btn-secondary text-xs px-4 py-2" data-testid="add-language-button">
          <Plus size={14} weight="bold" /> Add language
        </button>
      </div>
    </Section>
  );
}
